/* tslint:disable */
/* eslint-disable */
/**
 * LTCS gateway API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Offer } from './Offer';
import {
    OfferFromJSON,
    OfferFromJSONTyped,
    OfferToJSON,
} from './Offer';

/**
 * 
 * @export
 * @interface ApiV2OffersPost200Response
 */
export interface ApiV2OffersPost200Response {
    /**
     * 
     * @type {Array<Offer>}
     * @memberof ApiV2OffersPost200Response
     */
    offers?: Array<Offer>;
}

/**
 * Check if a given object implements the ApiV2OffersPost200Response interface.
 */
export function instanceOfApiV2OffersPost200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ApiV2OffersPost200ResponseFromJSON(json: any): ApiV2OffersPost200Response {
    return ApiV2OffersPost200ResponseFromJSONTyped(json, false);
}

export function ApiV2OffersPost200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiV2OffersPost200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'offers': !exists(json, 'offers') ? undefined : ((json['offers'] as Array<any>).map(OfferFromJSON)),
    };
}

export function ApiV2OffersPost200ResponseToJSON(value?: ApiV2OffersPost200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'offers': value.offers === undefined ? undefined : ((value.offers as Array<any>).map(OfferToJSON)),
    };
}

